export const STRAPI_URL =
  process.env.STRAPI_URL?.replace(/\/$/, "") || "http://localhost:1337";
